import {getCurrentYear} from "../../utils/Utils";
import React from "react";
import './LoginFormFooter.css';

const LoginFormFooter = () => {
    return (<footer>
        <div className="disclaimerSection">
            <p>
                © {getCurrentYear} OSTTRA Group. Proprietary and Confidential.
            </p>
            <p>
                <a className="disclaimerLink" target="_blank" rel="noreferrer"
                   href="https://osttra.com/disclaimer/">Disclaimer</a>
            </p>
            <p>
                <a target="_blank" rel="noreferrer"
                   href="https://osttra.com/osttra-terms-of-use/">Terms
                    of Use</a> |
                <a target="_blank" rel="noreferrer" href="https://osttra.com/privacy-policy/">Privacy
                    Policy</a> |
                <a target="_blank" rel="noreferrer"
                   href="https://osttra.com/cookies-policy/">Cookies</a>
            </p>
        </div>
    </footer>);

}
export default LoginFormFooter;